import { FC, useEffect, useState } from 'react'

import { Container } from 'components/container'
import { Share } from '../share'
import {
  StyledNav,
  Logo,
  LogoContainer,
  Content,
  Menu,
  MobileToggle,
  MobileContent,
  Backdrop,
} from './styled'
import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'
import { useAppContext } from 'context/app-context'
import { AnimatePresence } from 'framer-motion'

export const Header: FC<{
  onTop?: boolean
  isTransparent: boolean
  inverted: boolean
}> = () => {
  const { logoUrl } = useAppContext()
  const isSmall = useMedia([breakpoints.ltLarge], [true], false)
  const [isMenuOpen, setMenuOpen] = useState(false)
  const [isShareExpanded, setShareExpanded] = useState(isSmall)

  useEffect(() => {
    if (isMenuOpen) {
      document.documentElement.classList.add('locked')
    } else {
      document.documentElement.classList.remove('locked')
    }
  }, [isMenuOpen])

  return (
    <>
      <StyledNav>
        <Container $fluid>
          <LogoContainer href="/">
            <Logo src={logoUrl} />
          </LogoContainer>

          <MobileToggle onClick={() => setMenuOpen(v => !v)} />

          <AnimatePresence>
            {isSmall && isMenuOpen && (
              <Backdrop
                key="backdrop"
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.8 }}
                exit={{ opacity: 0 }}
                role="button"
                onClick={() => setMenuOpen(false)}
              />
            )}
            {(!isSmall || isMenuOpen) && (
              <MobileContent
                key="menu"
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
              >
                <Menu>
                  {/* <li> Список стран</li> */}
                  <li>
                    <a onClick={() => setMenuOpen(false)} href="#releases">
                      Выпуски
                    </a>
                  </li>
                  <li>
                    <a onClick={() => setMenuOpen(false)} href="#cast">
                      Ведущие
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => setMenuOpen(false)}
                      href="#previous-seasons"
                    >
                      Предыдущие сезоны
                    </a>
                  </li>
                </Menu>

                <Content>
                  <Share
                    isShare
                    isVisible={isShareExpanded}
                    onToggle={() => setShareExpanded(v => !v)}
                    onOpen={() => setShareExpanded(true)}
                    onClose={() => setShareExpanded(false)}
                  />
                </Content>
              </MobileContent>
            )}
          </AnimatePresence>
        </Container>
      </StyledNav>
    </>
  )
}
